import React from 'react'
import { Image, Row } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import { useTranslation } from 'react-i18next'
import { ComingSoonBadge, DurationBadge, LanguageBadge } from '../../Badge'
import WatchProgressBar from '../../WatchProgressBar'

const containerCss = css`
  position: relative;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  display: flex;
  width: 100%;
`
const badgesContainerCss = css`
  position: absolute;
  bottom: 12px;
  padding-inline: 12px;
  width: 100%;
`

const ImageBadges = ({ comingSoon = false, contentLocale, duration }) => {
  return (
    <Row gutters="none">
      <div growX />
      <LanguageBadge contentLocale={contentLocale} />
      {duration && <DurationBadge duration={duration} />}
      {comingSoon && <ComingSoonBadge />}
    </Row>
  )
}

export default function VideoThumbnail({
  thumbnail,
  duration,
  percentageWatched,
  comingSoon,
  contentLocale,
  isSession,
  heading,
  fill,
}) {
  const [t] = useTranslation()
  return (
    <div css={containerCss} is-session={boolAttr(isSession)}>
      <Image
        src={thumbnail}
        alt={t('card.image.alt.prefix', 'Thumbnail for {heading}', { heading })}
        loading="lazy"
        style={{ objectPosition: fill ? 'unset !important' : undefined }}
      />
      <div css={badgesContainerCss}>
        <ImageBadges comingSoon={comingSoon} contentLocale={contentLocale} duration={duration} />
      </div>
      <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
        <WatchProgressBar label={heading} percentageWatched={percentageWatched} />
      </div>
    </div>
  )
}
